import { Dialog, DialogActions, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, LinearProgress, MenuItem, Select, SelectProps, Checkbox, Typography, Box, IconButton, Paper } from '@mui/material';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { FieldAttributes, Form, Formik, useField } from 'formik';
import React, { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import * as yup from 'yup';
import { config } from '../../Constants';
import useAuth from "../../context/AuthProvider";
import { FMTextField } from '../Elements/input';

import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import TextField from '@mui/material/TextField';

import { FMSelectTaxTypeField, FMSelectTrueFalse } from '../Elements/select';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { height } from '@mui/system';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { apiClient } from '../../helper/api';

const selectFieldSx = {
  width: '100%',
  '& .MuiSelect-select': { padding: '14.5px 16px' },
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const textFieldSx = {
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
  '& .MuiInputBase-input': { padding: '3.5px 14px !important' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};

export interface TaxesAndFeeDataModel {
    paymentFilingScheduleId: number
    scheduleId?: number
    dueDate: string
    stateId: number,
    taxFeename: string
    taxesAndFeesFilingSchedulePeriodId: number
    jan: string
    feb: string
    mar: string
    apr: string
    may: string
    june: string
    july: string
    aug: string
    sept: string
    nov: string
    oct: string
    dec: string
    annualDate: string
    quarter1: string
    quarter2: string
    quarter3: string
    quarter4: string
    semiAnnualFirstHalf: string
    semiAnnualSecondHalf: string
    zeroFiling: string
    taxesAndFeesFilingSchedulePeriod?: string
    stateName: string
    taxesAndFilingSchedulePeriodId: number
    monthlyReportingDueDate: string
    withInDays?: string
    withInForteenDays: boolean
    dueImmediatelyUponInvoicing: boolean

    payment?: boolean
    report?: boolean
    wetSignature?: boolean
    notaryStamp?: boolean
    zeroIndividual?: boolean
    zeroEntity?: boolean
    paymentType?: string
    notes?: string
    name?: string

    // New fields added yesterday
    periodType?: string
    setDay?: number
    timePeriod?: string
    eom?: boolean
    skip?: boolean
    calculatedDueDates?: string[]

}


export const ModelCheck = yup.object({
    // taxFeename: yup.string().required('Select Tax').typeError("inavlid value"),
    // stateId: yup.number().min(1, "Select State").required("please select state").typeError("invalid value"),
    taxFeename: yup.string().required('Select Tax/Fee').typeError("Invalid Selection"),
    stateId: yup.number().min(1, "Please slecet state").required('Please select state').typeError("Invalid selection"),

})

interface Iprops {
    formValues: TaxesAndFeeDataModel
    handleClose: () => void,
    Open: boolean,
    handleSubmit: (StateID: string) => void
    RadioSelectedValue: string
    setRadioSelectedValue: React.Dispatch<React.SetStateAction<string>>
    setRadioSelectedValueZeroFiling: React.Dispatch<React.SetStateAction<string>>
    RadioSelectedValueZeroFiling: string
    RadioSelectValueDueImmediatlyUponInvoicing: string
    setRadioSelectedValueDueImmeditaly: React.Dispatch<React.SetStateAction<string>>

}

export const AddEditTaxFeeDate: React.FC<Iprops> = ({ formValues, handleClose, Open, handleSubmit, RadioSelectedValue, setRadioSelectedValue, setRadioSelectedValueZeroFiling, RadioSelectedValueZeroFiling, RadioSelectValueDueImmediatlyUponInvoicing, setRadioSelectedValueDueImmeditaly }) => {


    // const params = useParams();
    const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;
    const initialData = { stateId: 0, stateName: "" };
    const [States, setStates] = useState([initialData]);
    const [TaxandFees, setTaxandFees] = useState<string[]>([]);
    const [enhancedFormValues, setEnhancedFormValues] = useState<TaxesAndFeeDataModel>(formValues);
    const [calculatedDueDates, setCalculatedDueDates] = useState<any[]>([]);
    const [manualDueDates, setManualDueDates] = useState<{[key: string]: string}>({});
    


    const fetchData = () => {
        apiClient("/States/getStates", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (responseJson?.data != null) {
                    setStates(responseJson.data);
                }
                console.log("statesData", responseJson.data);
            })
    };

    const fetchTaxandFeesData = () => {
        apiClient(`/PolicyFilingType/GetAll`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (responseJson?.data != null) {
                    setTaxandFees(responseJson.data);
                }
                console.log("TaxandFees", responseJson.data);
            })
    };

    const fetchFilingScheduleDetails = (scheduleId: number) => {
        apiClient(`/TaxesAndFeesFilingSchedule/getFilingScheduleDetails?scheduleId=${scheduleId}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                // Map the API response data to form fields
                if (responseJson?.data && Array.isArray(responseJson.data) && responseJson.data.length > 0) {
                    const apiData = responseJson.data;
                    const firstItem = apiData[0]; // Use first item as the base data
                    
                    // Store the calculated due dates array
                    setCalculatedDueDates(apiData);
                    
                    // Update the enhanced form values with API data
                    setEnhancedFormValues(prev => ({
                        ...prev,
                        // Map API response fields to form fields
                        periodType: firstItem.periodType || prev.periodType,
                        setDay: firstItem.setDay || prev.setDay,
                        eom: firstItem.endOfMonth !== null ? firstItem.endOfMonth : prev.eom,
                        skip: firstItem.skip !== null ? firstItem.skip : prev.skip,
                        timePeriod: firstItem.timePeriod || prev.timePeriod,
                    }));
                }
            })
            .catch((error) => {
                console.error("Error fetching filing schedule details:", error);
            });
    };

    useEffect(() => {
        fetchData();
        fetchTaxandFeesData();
    }, [token]);

    // Update enhanced form values when formValues change
    useEffect(() => {
        // Preserve API-loaded data when updating form values
        setEnhancedFormValues(prev => ({
            ...formValues,  // Use formValues as base
            // Preserve API-loaded fields if they exist
            periodType: prev.periodType || formValues.periodType,
            setDay: prev.setDay || formValues.setDay,
            timePeriod: prev.timePeriod || formValues.timePeriod,
            eom: prev.eom !== undefined ? prev.eom : formValues.eom,
            skip: prev.skip !== undefined ? prev.skip : formValues.skip,
        }));
    }, [formValues, States]);

    // Fetch filing schedule details when popup opens with data
    useEffect(() => {
        if (Open && formValues && (formValues.paymentFilingScheduleId || formValues.scheduleId)) {
            const scheduleId = formValues.paymentFilingScheduleId || formValues.scheduleId;
            if (scheduleId) {
                fetchFilingScheduleDetails(scheduleId);
            }
        }
    }, [Open, formValues]);

    // const FMSelectState: React.FC<FieldAttributes<SelectProps>> = ({
    //     variant,
    //     ...props
    // }) => {
    //     const [field, meta] = useField<{}>(props);
    //     const errorText = meta.error && meta.touched ? meta.error : "";
    //     const { user } = useAuth();
    //     const token = user?.token;
    //     const initialdata = { stateId: 0, stateName: "" };
    //     const [States, setStates] = useState([initialdata]);

    //     const fetchData = () => {
    //         fetch(config.url.API_URL + "/States/getStates", {
    //             method: "GET",
    //             headers: new Headers({
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${token}`,
    //             }),
    //         })
    //             .then((response) => {
    //                 if (response.ok) {
    //                     return response.json();
    //                 }
    //                 throw new Error("Something went wrong");
    //             })
    //             .then((responseJson) => {
    //                 // Do something with the response
    //                 if (responseJson.data != null) {
    //                     setStates(responseJson.data);
    //                 }

    //                 console.log("statesDAta", responseJson.data);
    //             })
    //             .catch((error) => {
    //                 console.log(error);
    //             });
    //     };


    //     useEffect(() => {
    //         fetchData();
    //     }, []);

    //     return (
    //         <FormControl error={!!errorText} fullWidth>
    //             {/* <FormHelperText>Select State</FormHelperText> */}
    //             <InputLabel id="State-Select-Label"></InputLabel>
    //             <Select
    //                 {...field}
    //                 labelId="State-Select-Label"
    //                 // label="State"
    //                 IconComponent={ExpandMoreIcon}
    //                 label={null}
    //                 className="border-round custom-menu-item "
    //             >
    //                 <MenuItem key={0} value={0}>
    //                     {" "}
    //                     {" "}
    //                 </MenuItem>
    //                 {States.map((state, key) => (
    //                     <MenuItem key={key} value={state.stateId}>
    //                         {" "}
    //                         {state.stateName}{" "}
    //                     </MenuItem>
    //                 ))}
    //             </Select>
    //         </FormControl>
    //     );
    // };

    const RadioValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        setRadioSelectedValue((event.target as HTMLInputElement).value);

    };
    const RadioValueChangefiling = (event: React.ChangeEvent<HTMLInputElement>) => {

        setRadioSelectedValueZeroFiling((event.target as HTMLInputElement).value);

    };
    const RadioValueChangeDueImmediatlyUponInvoicing = (event: React.ChangeEvent<HTMLInputElement>) => {

        setRadioSelectedValueDueImmeditaly((event.target as HTMLInputElement).value);

    };

    // Helper function to format date for display
    const formatDueDate = (dateString: string) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            // Use UTC methods to avoid timezone conversion issues
            return date.toLocaleDateString('en-US', { 
                month: '2-digit', 
                day: '2-digit', 
                year: 'numeric',
                timeZone: 'UTC'  // Force UTC timezone to prevent local timezone conversion
            });
        } catch (error) {
            return dateString;
        }
    };

    // Helper function to get due date for a specific period
    const getDueDateForPeriod = (period: number) => {
        const periodKey = `period_${period}`;
        // Check if there's a manual override first
        if (manualDueDates[periodKey]) {
            return manualDueDates[periodKey];
        }
        // Otherwise use calculated date
        const dueDateItem = calculatedDueDates.find(item => item.period === period);
        return dueDateItem ? formatDueDate(dueDateItem.dueDate) : '';
    };

    // Helper function to handle manual date changes
    const handleManualDateChange = (period: number, value: string) => {
        const periodKey = `period_${period}`;
        setManualDueDates(prev => ({
            ...prev,
            [periodKey]: value
        }));
    };

    // Function to calculate due dates based on Set Day and Period Type
    const calculateDueDatesFromSetDay = (setDay: number, periodType: string, eom: boolean) => {
        if (!periodType) return {};
        if (!eom && !setDay) return {}; // Only require setDay when EOM is not checked

        const currentYear = new Date().getFullYear();
        const calculatedDates: {[key: string]: string} = {};

        if (eom) {
            // If EOM is checked, use end of month logic - copy exact working logic from non-EOM
            if (periodType === 'Monthly') {
                for (let month = 1; month <= 12; month++) {
                    // Use last day of month instead of setDay
                    const lastDayOfMonth = new Date(currentYear, month, 0).getDate();
                    const actualDay = lastDayOfMonth; // EOM = use last day instead of Math.min(setDay, lastDayOfMonth)
                    const date = new Date(currentYear, month - 1, actualDay);
                    calculatedDates[`period_${month}`] = date.toLocaleDateString('en-US', { 
                        month: '2-digit', 
                        day: '2-digit', 
                        year: 'numeric' 
                    });
                }
            } else if (periodType === 'Quarterly') {
                // Q1: March, Q2: June, Q3: September, Q4: December
                const quarterMonths = [3, 6, 9, 12];
                quarterMonths.forEach((month, index) => {
                    const lastDayOfMonth = new Date(currentYear, month, 0).getDate();
                    const actualDay = lastDayOfMonth; // EOM = use last day instead of Math.min(setDay, lastDayOfMonth)
                    const date = new Date(currentYear, month - 1, actualDay);
                    calculatedDates[`period_${index + 1}`] = date.toLocaleDateString('en-US', { 
                        month: '2-digit', 
                        day: '2-digit', 
                        year: 'numeric' 
                    });
                });
            } else if (periodType === 'Semi-Annual') {
                // First Half: June, Second Half: December
                const semiAnnualMonths = [6, 12];
                semiAnnualMonths.forEach((month, index) => {
                    const lastDayOfMonth = new Date(currentYear, month, 0).getDate();
                    const actualDay = lastDayOfMonth; // EOM = use last day instead of Math.min(setDay, lastDayOfMonth)
                    const date = new Date(currentYear, month - 1, actualDay);
                    calculatedDates[`period_${index + 1}`] = date.toLocaleDateString('en-US', { 
                        month: '2-digit', 
                        day: '2-digit', 
                        year: 'numeric' 
                    });
                });
            } else if (periodType === 'Annual') {
                // December of current year
                const lastDayOfYear = new Date(currentYear, 12, 0).getDate();
                const actualDay = lastDayOfYear; // EOM = use last day instead of Math.min(setDay, lastDayOfYear)
                const date = new Date(currentYear, 11, actualDay);
                calculatedDates[`period_1`] = date.toLocaleDateString('en-US', { 
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric' 
                });
            }
        } else {
            // Use the specific set day
            if (periodType === 'Monthly') {
                for (let month = 1; month <= 12; month++) {
                    // Ensure the day doesn't exceed the number of days in the month
                    const lastDayOfMonth = new Date(currentYear, month, 0).getDate();
                    const actualDay = Math.min(setDay, lastDayOfMonth);
                    const date = new Date(currentYear, month - 1, actualDay);
                    calculatedDates[`period_${month}`] = date.toLocaleDateString('en-US', { 
                        month: '2-digit', 
                        day: '2-digit', 
                        year: 'numeric' 
                    });
                }
            } else if (periodType === 'Quarterly') {
                // Q1: March, Q2: June, Q3: September, Q4: December
                const quarterMonths = [3, 6, 9, 12];
                quarterMonths.forEach((month, index) => {
                    const lastDayOfMonth = new Date(currentYear, month, 0).getDate();
                    const actualDay = Math.min(setDay, lastDayOfMonth);
                    const date = new Date(currentYear, month - 1, actualDay);
                    calculatedDates[`period_${index + 1}`] = date.toLocaleDateString('en-US', { 
                        month: '2-digit', 
                        day: '2-digit', 
                        year: 'numeric' 
                    });
                });
            } else if (periodType === 'Semi-Annual') {
                // First Half: June, Second Half: December
                const semiAnnualMonths = [6, 12];
                semiAnnualMonths.forEach((month, index) => {
                    const lastDayOfMonth = new Date(currentYear, month, 0).getDate();
                    const actualDay = Math.min(setDay, lastDayOfMonth);
                    const date = new Date(currentYear, month - 1, actualDay);
                    calculatedDates[`period_${index + 1}`] = date.toLocaleDateString('en-US', { 
                        month: '2-digit', 
                        day: '2-digit', 
                        year: 'numeric' 
                    });
                });
            } else if (periodType === 'Annual') {
                // December of current year
                const lastDayOfYear = new Date(currentYear, 11, 0).getDate();
                const actualDay = Math.min(setDay, lastDayOfYear);
                const date = new Date(currentYear, 11, actualDay);
                calculatedDates[`period_1`] = date.toLocaleDateString('en-US', { 
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric' 
                });
            }
        }

        return calculatedDates;
    };

    // Function to handle Set Day changes and update calculated dates
    const handleSetDayChange = (setDay: number, periodType: string, eom: boolean, setFieldValue: any) => {
        const calculatedDates = calculateDueDatesFromSetDay(setDay, periodType, eom);
        setManualDueDates(calculatedDates);
    };

    // Function to handle EOM changes and update calculated dates
    const handleEOMChange = (eom: boolean, periodType: string, setDay: number, setFieldValue: any) => {
        if (eom && periodType) {
            // When EOM is checked, look at existing dates and set each to end of its current month
            const updatedDates: {[key: string]: string} = {};
            
            // Get the number of periods based on period type
            let periods = 1;
            if (periodType === 'Monthly') periods = 12;
            else if (periodType === 'Quarterly') periods = 4;
            else if (periodType === 'Semi-Annual') periods = 2;
            
            for (let i = 1; i <= periods; i++) {
                // Get the current displayed date using the same logic as getDueDateForPeriod
                const currentDisplayedDate = getDueDateForPeriod(i);
                
                if (currentDisplayedDate) {
                    // Parse existing date to get the month/year
                    const date = new Date(currentDisplayedDate);
                    if (!isNaN(date.getTime())) {
                        const year = date.getFullYear();
                        const month = date.getMonth(); // 0-based month
                        
                        // Get last day of that month
                        const lastDay = new Date(year, month + 1, 0).getDate();
                        const eomDate = new Date(year, month, lastDay);
                        
                        updatedDates[`period_${i}`] = eomDate.toLocaleDateString('en-US', { 
                            month: '2-digit', 
                            day: '2-digit', 
                            year: 'numeric' 
                        });
                    }
                }
            }
            
            setManualDueDates(prev => ({ ...prev, ...updatedDates }));
        } else if (!eom && setDay && periodType) {
            // When EOM is unchecked, recalculate using setDay if available
            const calculatedDates = calculateDueDatesFromSetDay(setDay, periodType, eom);
            setManualDueDates(calculatedDates);
        }
    };

    // Helper function to calculate TimePeriod (the period BEFORE the due date)
    const calculateTimePeriod = (dueDate: Date, periodType: string, periodNumber: number): string => {
        const year = dueDate.getFullYear();
        const month = dueDate.getMonth(); // 0-based month
        
        if (periodType === 'Monthly') {
            // For monthly, TimePeriod is the previous month
            const prevMonth = month === 0 ? 11 : month - 1;
            const prevYear = month === 0 ? year - 1 : year;
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                              'July', 'August', 'September', 'October', 'November', 'December'];
            return monthNames[prevMonth];
        } else if (periodType === 'Quarterly') {
            const quarterPeriods = [
                'January - March',
                'April - June',
                'July - September',
                'October - December',
            ];
            return quarterPeriods[periodNumber - 1] || '';
        } else if (periodType === 'Semi-Annual') {
            const semiAnnualPeriods = [
                'January - June',
                'July - December',
            ];
            return semiAnnualPeriods[periodNumber - 1] || '';
        } else if (periodType === 'Annual') {
            return 'January - December';
        }
        
        return '';
    };

    // Helper function to get date from old format based on period type and number
    const getDateFromOldFormat = (values: any, periodType: string, periodNumber: number): string => {
        console.log(`=== GET DATE FROM OLD FORMAT ===`);
        console.log(`Period Type: ${periodType}, Period Number: ${periodNumber}`);
        
        if (periodType === 'Monthly') {
            const monthFields = ['jan', 'feb', 'mar', 'apr', 'may', 'june', 
                               'july', 'aug', 'sept', 'oct', 'nov', 'dec'];
            const result = values[monthFields[periodNumber - 1]] || '';
            console.log(`Monthly result for ${monthFields[periodNumber - 1]}:`, result);
            return result;
        } else if (periodType === 'Quarterly') {
            const quarterFields = ['quarter1', 'quarter2', 'quarter3', 'quarter4'];
            const result = values[quarterFields[periodNumber - 1]] || '';
            console.log(`Quarterly result for ${quarterFields[periodNumber - 1]}:`, result);
            return result;
        } else if (periodType === 'Semi-Annual') {
            const semiFields = ['semiAnnualFirstHalf', 'semiAnnualSecondHalf'];
            const result = values[semiFields[periodNumber - 1]] || '';
            console.log(`Semi-Annual result for ${semiFields[periodNumber - 1]}:`, result);
            return result;
        } else if (periodType === 'Annual') {
            const result = values.annualDate || '';
            console.log(`Annual result for annualDate:`, result);
            console.log(`Full values object:`, values);
            return result;
        }
        console.log(`No matching period type, returning empty string`);
        return '';
    };

    // Helper function to prepare filing schedule periods for API
    const prepareFilingSchedulePeriods = (values: any): any[] => {
        console.log("=== PREPARE FILING SCHEDULE PERIODS ===");
        console.log("Values received:", values);
        console.log("Period Type:", values.periodType);
        
        const periods: any[] = [];
        
        if (!values.periodType) {
            console.log("No period type found, returning empty periods");
            return periods;
        }
        
        let periodCount = 1;
        if (values.periodType === 'Monthly') periodCount = 12;
        else if (values.periodType === 'Quarterly') periodCount = 4;
        else if (values.periodType === 'Semi-Annual') periodCount = 2;
        else if (values.periodType === 'Annual') periodCount = 1;
        
        console.log("Period count for", values.periodType, ":", periodCount);
        
        for (let i = 1; i <= periodCount; i++) {
            console.log(`Processing period ${i} of ${periodCount}`);
            
            // First try to get from new period structure (manual/calculated dates)
            let dueDateString = getDueDateForPeriod(i);
            console.log(`New format date for period ${i}:`, dueDateString);
            
            // If not found, try to get from old format
            if (!dueDateString) {
                dueDateString = getDateFromOldFormat(values, values.periodType, i);
                console.log(`Old format date for period ${i}:`, dueDateString);
            }
            
            if (dueDateString) {
                const dueDate = new Date(dueDateString);
                console.log(`Parsed date for period ${i}:`, dueDate);
                
                if (!isNaN(dueDate.getTime())) {
                    const timePeriod = calculateTimePeriod(dueDate, values.periodType, i);
                    console.log(`Time period for period ${i}:`, timePeriod);
                    
                    const periodObj = {
                        ScheduleId: values.scheduleId || 0, // Will be set by backend if new
                        DueDate: dueDate.toISOString().split('T')[0], // Format as YYYY-MM-DD
                        Skip: values.skip || false,
                        TimePeriod: timePeriod,
                        Period: i
                    };
                    
                    console.log(`Period object for period ${i}:`, periodObj);
                    periods.push(periodObj);
                } else {
                    console.log(`Invalid date for period ${i}:`, dueDateString);
                }
            } else {
                console.log(`No date found for period ${i}`);
            }
        }
        
        console.log("Final periods array:", periods);
        console.log("=== END PREPARE FILING SCHEDULE PERIODS ===");
        return periods;
    };
    const FMSelectState: React.FC<FieldAttributes<SelectProps>> = ({
        variant,
        ...props
    }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";

        return (
            <FormControl error={!!errorText} fullWidth>
                <InputLabel id="State-Select-Label"></InputLabel>
                <Select
                    {...field}
                    labelId="State-Select-Label"
                    IconComponent={ExpandMoreIcon}
                    label={null}
                    className="border-round custom-menu-item"
                    variant={variant || "outlined"}
                    margin="dense"
                    sx={{ m: 2 }}
                >
                    <MenuItem key={0} value={0}>{" "}</MenuItem>
                    {States.map((state, key) => (
                        <MenuItem key={key} value={state.stateId}>
                            {" "}
                            {state.stateName}{" "}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    };

    const FMSelectTrueFalseCustom: React.FC<FieldAttributes<SelectProps>> = ({ variant, ...props }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";

        return (
            <React.Fragment>
                <FormControl error={!!errorText} className="border-round select-input-border" fullWidth>
                    <Select {...field} label={null}
                        IconComponent={ExpandMoreIcon}
                    >
                        <MenuItem value={true as any}>True</MenuItem>
                        <MenuItem value={false as any}>False</MenuItem>

                    </Select>
                    <FormHelperText>{errorText}</FormHelperText>
                </FormControl>
            </React.Fragment>

        )
    };
   
    const FMSelectTaxAndFeesustom: React.FC<FieldAttributes<SelectProps>> = ({
        variant,
        ...props
    }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";
        const { user } = useAuth();
        const token = user?.token;

        // useEffect(() => {
        //     fetchTaxandFeesData();
        // }, []);
        return (
            <FormControl error={!!errorText} fullWidth>
                <InputLabel id="State-Select-Label"></InputLabel>
                <Select {...field} labelId="State-Select-Label" label="TaxandFees"
                    className="border-round main-form-2"
                    IconComponent={ExpandMoreIcon}
                >

                    {TaxandFees.map((taxandfees, key) => (
                        <MenuItem key={key} value={taxandfees}>
                            {" "}
                            {taxandfees}{" "}
                        </MenuItem>
                    ))}
                </Select>

                <FormHelperText>{errorText}</FormHelperText>
            </FormControl>
        );
    };



    return (
        <Dialog
            open={Open}
            onClose={handleClose}
            maxWidth="xl"
            fullWidth
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 900,
                    minHeight: '70vh',
                    maxHeight: '90vh',
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
        >
            {loading && <LinearProgress sx={{ flexShrink: 0 }} />}
            <DialogTitle
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <EventNoteOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        {formValues.stateName}: {formValues.name}
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleClose}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <LocalizationProvider dateAdapter={AdapterDayjs} >
                <Formik initialValues={enhancedFormValues}
                    enableReinitialize={true}
                    validateOnChange={true}
                    // validationSchema={ModelCheck} // Temporarily disabled for debugging
                    onSubmit={(data, { setSubmitting }) => {
                        console.log("=== SUBMIT HANDLER CALLED ===");
                        console.log("Form data received:", data);

                        if (data.stateId === null || data.stateId === 0) {
                            alert("please Select State");
                            setSubmitting(false);
                            return;
                        }
                        if (data.taxFeename === null || data.taxFeename === '') {
                            alert("please Select Tax/Fee");
                            setSubmitting(false);
                            return;
                        }
                        // Handle RadioSelectedValue before setting taxesAndFeesFilingSchedulePeriodId
                        let finalRadioSelectedValue = RadioSelectedValue;
                        if (RadioSelectedValue === "12")
                            finalRadioSelectedValue = "0";
                            
                        data.taxesAndFeesFilingSchedulePeriodId = Number(finalRadioSelectedValue) || 1; // Default to 1 if null/undefined
                        if (data.taxFeename !== "Stamping Fee" && RadioSelectValueDueImmediatlyUponInvoicing === "12")
                            RadioSelectValueDueImmediatlyUponInvoicing = "0"


                        if (RadioSelectedValueZeroFiling === "7" && data.zeroFiling === "") {
                            alert("please enter zero filing date");
                            setSubmitting(false);
                            return;
                        }
                        if (finalRadioSelectedValue === "0" && RadioSelectValueDueImmediatlyUponInvoicing !== "12") {

                            alert("please select any Schedule Period");
                            setSubmitting(false);
                            return;
                        }
                        if (finalRadioSelectedValue === "9")
                            data.withInForteenDays = true;
                        else
                            data.withInForteenDays = false;

                        if (finalRadioSelectedValue !== "11")
                            data.withInDays = "";

                        if (RadioSelectValueDueImmediatlyUponInvoicing === "12") {
                            data.dueImmediatelyUponInvoicing = true;
                            if (finalRadioSelectedValue === "0")
                                data.taxesAndFeesFilingSchedulePeriodId = Number(RadioSelectValueDueImmediatlyUponInvoicing)
                        }

                        else
                            data.dueImmediatelyUponInvoicing = false;
                        if (data.notes === null) {
                            data.notes = ""
                        }
                        else {
                            data.notes = data.notes;
                        }


                        // Prepare the filing schedule periods data
                        const filingSchedulePeriods = prepareFilingSchedulePeriods(data);
                        
                        // Create the complete payload with nested periods and required fields
                        const payload = {
                            ...data,
                            // Fix field naming and add required fields
                            taxFeeName: data.taxFeename || data.name,  // Use taxFeename or fallback to name
                            paymentFilingScheduleId: data.scheduleId || 0,  // Required field matching scheduleId
                            filingSchedulePeriods: filingSchedulePeriods  // Backend expects JSON array
                        };

                        // Debug logging to verify required fields
                        console.log("=== PAYLOAD VERIFICATION ===");
                        console.log("taxFeeName:", payload.taxFeeName);
                        console.log("taxesAndFeesFilingSchedulePeriodId:", payload.taxesAndFeesFilingSchedulePeriodId);
                        console.log("paymentFilingScheduleId:", payload.paymentFilingScheduleId);
                        console.log("RadioSelectedValue:", RadioSelectedValue);
                        console.log("=== END VERIFICATION ===");

                        console.log("=== COMPLETE PAYLOAD ===");
                        console.log("Main Data:", data);
                        console.log("Filing Schedule Periods:", filingSchedulePeriods);
                        console.log("Complete Payload:", payload);
                        console.log("=== END PAYLOAD ===");
                        
                        setloading(true);
                        apiClient('/TaxesAndFeesFilingSchedule/UpdateTaxesAndFeesFilingScheduleDate',
                            {
                                method: 'POST',

                                headers: new Headers({
                                    'Content-Type': 'application/json',
                                    'Authorization': `Bearer ${token}`,
                                }),
                                body: JSON.stringify(payload)  // <-- Send complete payload with periods

                            })
                            .then((res) => {
                                if (!res) return
                                // fetchData();
                                // Do something with the response
                                Swal.fire({
                                    title: res.message,
                                    text: "",
                                    icon: res.data === 1 ? "success" : res.data === 2 ? "warning" : "info",
                                    confirmButtonText: "OK",
                                });
                                handleClose();

                            }).finally(() => {
                                setSubmitting(false);
                                setloading(false);
                            })

                    }} >
                    {({ values, isSubmitting, setFieldValue, errors, touched }) => {
                        console.log("=== CURRENT FORM VALUES IN RENDER ===");
                        console.log("values.stateId:", values.stateId);
                        console.log("values.stateName:", values.stateName);
                        console.log("All values:", values);
                        console.log("Validation errors:", errors);
                        console.log("Touched fields:", touched);
                        console.log("=== END CURRENT FORM VALUES ===");
                        
                        return (
                        <Form className='main-form overflow-auto'>
                            <DialogContent sx={{ width: '100%', minHeight: '53.5vh', p: '0px' , '& > .MuiGrid-root': { px: { xs: 2, sm: 3 }, py: 3 } }}>
                            <Grid container spacing={3}>
                                {/* Section: Schedule details */}
                                <Grid item xs={12}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                        Schedule details
                                    </Typography>
                                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={3}>
                                            <FormControl sx={{ width: '100%' }}>
                                                <FormHelperText className='formtexthelper-heading'>
                                                    State
                                                </FormHelperText>
                                                <Select
                                                    name="stateId"
                                                    value={values.stateId || 0}
                                                    onChange={(e) => {
                                                        console.log("State changed to:", e.target.value);
                                                        setFieldValue('stateId', e.target.value);
                                                    }}
                                                    variant="outlined"
                                                    margin="dense"
                                                    fullWidth
                                                    IconComponent={ExpandMoreIcon}
                                                    sx={selectFieldSx}
                                                >
                                                    <MenuItem value={0}> </MenuItem>
                                                    {States.map((state, key) => (
                                                        <MenuItem key={key} value={state.stateId}>
                                                            {state.stateName}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                            <FormControl sx={{ width: '100%' }}>
                                                <FormHelperText className='formtexthelper-heading'>
                                                    Payment Type
                                                </FormHelperText>
                                                <FMTextField name="paymentType" type="Text" fullWidth variant="outlined" sx={textFieldSx} />
                                            </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                            <FormControl sx={{ width: '100%' }}>
                                                <FormHelperText className='formtexthelper-heading'>
                                                    Period Type
                                                </FormHelperText>
                                                <Select
                                                    name="periodType"
                                                    value={values.periodType || ''}
                                                    onChange={(e) => {
                                                        setFieldValue('periodType', e.target.value);
                                                        // Trigger calculation when Period Type changes
                                                        if (values.setDay && e.target.value) {
                                                            handleSetDayChange(values.setDay, e.target.value, values.eom || false, setFieldValue);
                                                        }
                                                    }}
                                                    variant="outlined"
                                                    margin="dense"
                                                    fullWidth
                                                    sx={selectFieldSx}
                                                >
                                                    <MenuItem value="Monthly">Monthly</MenuItem>
                                                    <MenuItem value="Quarterly">Quarterly</MenuItem>
                                                    <MenuItem value="Semi-Annual">Semi-Annual</MenuItem>
                                                    <MenuItem value="Annual">Annual</MenuItem>
                                                </Select>
                                            </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                            <FormControl sx={{ width: '100%' }}>
                                                <FormHelperText className='formtexthelper-heading'>
                                                    Set Day
                                                </FormHelperText>
                                                <TextField
                                                    name="setDay"
                                                    type="number"
                                                    inputProps={{ min: 1, max: 31 }}
                                                    value={values.setDay || ''}
                                                    onChange={(e) => {
                                                        const newSetDay = parseInt(e.target.value) || 0;
                                                        setFieldValue('setDay', newSetDay);
                                                        // Trigger calculation when Set Day changes
                                                        if (newSetDay && values.periodType) {
                                                            handleSetDayChange(newSetDay, values.periodType, values.eom || false, setFieldValue);
                                                        }
                                                    }}
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={textFieldSx}
                                                />
                                            </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>

                                {/* Section: Options */}
                                <Grid item xs={12}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                        Options
                                    </Typography>
                                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50', mb: 2 }}>
                                        <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                                <FormControlLabel 
                                                    control={
                                                        <Checkbox
                                                            checked={values.payment || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                                setFieldValue('payment', e.target.checked)
                                                            }
                                                            name="payment"
                                                        />
                                                    }
                                                    label="Payment"
                                                />
                                                {/* 3. Reports */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.report || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                                setFieldValue('report', e.target.checked)
                                                            }
                                                            name="report"
                                                        />
                                                    }
                                                    label="Reports"
                                                />
                                                {/* 4. Wet Signature */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.wetSignature || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                                setFieldValue('wetSignature', e.target.checked)
                                                            }
                                                            name="wetSignature"
                                                        />
                                                    }
                                                    label="Wet Signature"
                                                />

                                                {/* 5. Notary Stamp */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.notaryStamp || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                                setFieldValue('notaryStamp', e.target.checked)
                                                            }
                                                            name="notaryStamp"
                                                        />
                                                    }
                                                    label="Notary Stamp"
                                                />

                                                {/* 6. Zero Entity */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.zeroEntity || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                                setFieldValue('zeroEntity', e.target.checked)
                                                            }
                                                            name="zeroEntity"
                                                        />
                                                    }
                                                    label="Zero Entity"
                                                />

                                                {/* 7. Zero Individual */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.zeroIndividual || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                                setFieldValue('zeroIndividual', e.target.checked)
                                                            }
                                                            name="zeroIndividual"
                                                        />
                                                    }
                                                    label="Zero Individual"
                                                />
                                                {/* 8. EOM */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.eom || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                                setFieldValue('eom', e.target.checked);
                                                                // Trigger calculation when EOM changes
                                                                handleEOMChange(e.target.checked, values.periodType || '', values.setDay || 0, setFieldValue);
                                                            }}
                                                            name="eom"
                                                        />
                                                    }
                                                    label="EOM (End of Month)"
                                                />

                                                {/* 9. Skip (BIT) */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.skip || false}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                                                                setFieldValue('skip', e.target.checked)
                                                            }
                                                            name="skip"
                                                        />
                                                    }
                                                    label="Skip"
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormControl sx={{ width: '100%' }}>
                                                <FormHelperText className='formtexthelper-heading'>Notes</FormHelperText>
                                                <FMTextField name="notes" margin="dense" multiline rows={2} type="Text" fullWidth variant="outlined" sx={{ ...textFieldSx }} />
                                            </FormControl>
                                        </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>

                                {/* Section: Calculated due dates */}
                                {(values.periodType === 'Monthly' || values.periodType === 'Quarterly' || values.periodType === 'Semi-Annual' || values.periodType === 'Annual')
                                && (
                                    <Grid item xs={12}>
                                        <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                            Calculated due dates
                                        </Typography>
                                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50', mb: 2 }}>
                                        <Grid container spacing={2} key={`calculated-dates-${calculatedDueDates.length}`}>
                                            {values.periodType === 'Monthly' && (
                                                <>
                                                    {[...Array(12)].map((_, index) => (
                                                        <Grid item xs={2} key={index}>
                                                            <FormControl sx={{ width: '100%' }}>
                                                                <FormHelperText className='formtexthelper-heading'>
                                                                    {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                                                                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][index]}
                                                                </FormHelperText>
                                                                <TextField 
                                                                    name={`calculated_${index}`}
                                                                    value={getDueDateForPeriod(index + 1)}
                                                                    onChange={(e) => handleManualDateChange(index + 1, e.target.value)}
                                                                    placeholder="MM/DD/YYYY"
                                                                    margin="dense" 
                                                                    fullWidth 
                                                                    variant="outlined" 
                                                                    sx={{ ...textFieldSx, m: 1 }}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                    ))}
                                                </>
                                            )}

                                            {values.periodType === 'Quarterly' && (
                                                <>
                                                    {['Q1', 'Q2', 'Q3', 'Q4'].map((quarter, index) => (
                                                        <Grid item xs={3} key={index}>
                                                            <FormControl sx={{ width: '100%' }}>
                                                                <FormHelperText className='formtexthelper-heading'>
                                                                    {quarter}
                                                                </FormHelperText>
                                                                <TextField 
                                                                    name={`calculated_${index}`}
                                                                    value={getDueDateForPeriod(index + 1)}
                                                                    onChange={(e) => handleManualDateChange(index + 1, e.target.value)}
                                                                    placeholder="MM/DD/YYYY"
                                                                    margin="dense" 
                                                                    fullWidth 
                                                                    variant="outlined" 
                                                                    sx={{ ...textFieldSx, m: 1 }}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                    ))}
                                                </>
                                            )}

                                            {values.periodType === 'Semi-Annual' && (
                                                <>
                                                    {['First Half', 'Second Half'].map((half, index) => (
                                                        <Grid item xs={6} key={index}>
                                                            <FormControl sx={{ width: '100%' }}>
                                                                <FormHelperText className='formtexthelper-heading'>
                                                                    {half}
                                                                </FormHelperText>
                                                                <TextField 
                                                                    name={`calculated_${index}`}
                                                                    value={getDueDateForPeriod(index + 1)}
                                                                    onChange={(e) => handleManualDateChange(index + 1, e.target.value)}
                                                                    placeholder="MM/DD/YYYY"
                                                                    margin="dense" 
                                                                    fullWidth 
                                                                    variant="outlined" 
                                                                    sx={{ ...textFieldSx, m: 1 }}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                    ))}
                                                </>
                                            )}

                                            {values.periodType === 'Annual' && (
                                                <Grid item xs={12}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className='formtexthelper-heading'>
                                                            Annual Due Date
                                                        </FormHelperText>
                                                        <TextField 
                                                            name="calculated_annual"
                                                            value={getDueDateForPeriod(1)}
                                                            onChange={(e) => handleManualDateChange(1, e.target.value)}
                                                            placeholder="MM/DD/YYYY"
                                                            margin="dense" 
                                                            fullWidth 
                                                            variant="outlined" 
                                                            sx={{ ...textFieldSx, m: 1 }}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            )}
                                        </Grid>
                                        </Paper>
                                    </Grid>
                                )}
                            </Grid>
                                                                                    <DialogActions
                                    sx={{
                                        px: 3,
                                        py: 2,
                                        gap: 1.5,
                                        borderTop: 1,
                                        borderColor: 'divider',
                                        backgroundColor: 'grey.50',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        onClick={handleClose}
                                        startIcon={<CloseOutlinedIcon />}
                                        sx={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            borderColor: '#e2e8f0',
                                            color: '#475569',
                                            '&:hover': {
                                                borderColor: '#2099d2',
                                                backgroundColor: '#2099d214',
                                                color: '#2099d2',
                                            },
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        type="submit"
                                        disabled={isSubmitting}
                                        sx={{
                                            textTransform: 'none',
                                            fontWeight: 600,
                                            backgroundColor: '#2099d2',
                                            '&:hover': { backgroundColor: '#176990' },
                                            px: 2.5,
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </DialogActions>

                            </DialogContent>
                        </Form>
                    );
                    }}
                </Formik>
            </LocalizationProvider>
        </Dialog>
    )
}